import { Base } from "../../../../base/components/base"
import { Img } from "../../../../base/components/native/img"
import { TABLE_DIM } from "../../../../configs/config"
import { IMAGES } from "../../../../configs/images"
import { RateTh } from "./rate-th"
import { RateTr } from "./rate-tr"

export const RateToCadHeader = () => {

    const base = RateTr()
    base.style({ display: 'flex' })

    const title = RateTh('')
    title.cssClass({ width: '110px' })

    const sell = RateTh('We Sell')
    sell.cssClass({ width: '150px', display: 'flex', fontWeight: 'normal', color: 'gray', justifyContent: 'flex-end' })

    const buy = RateTh('We Buy')
    buy.cssClass({ width: '150px', display: 'flex', fontWeight: 'normal', color: 'gray', justifyContent: 'flex-end' })

    const db = RateTh()
    db.cssClass({ width: '90px', paddingRight: '10px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' })
    const dbIcon = Img(IMAGES.ICONS.DATABASE, { width: 20, })
    dbIcon.el.setAttribute('title', 'بروزرسانی دیتابیس')
    db.append(dbIcon)

    // const telegram = RateTh()
    // telegram.cssClass({ width: '30px', paddingRight: '10px' })
    // const telegramIcon = Img(IMAGES.ICONS.TELEGRAM, { width: 24 })
    // telegramIcon.el.setAttribute('title', 'ارسال به تلگرام')
    // telegram.append(telegramIcon)

    base.append(title, sell, buy, db)

    return base
}